var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Lang, LanguageService } from './language.service';
import { PageService } from '../../models/page.service';
import { MessageService } from '../../service/message.service';
import { AuAction } from '../../action/au.action';
import { ContentBaseComponent } from '../base/contentbase.component';
var LanguageComponent = /** @class */ (function (_super) {
    __extends(LanguageComponent, _super);
    function LanguageComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.saveDefaultLang = true;
        _this.componentName = LanguageComponent.name;
        _this.user_lang = new Lang();
        _this.select_lang = '';
        _this.current_lang = '';
        _this.save_default = false;
        _this.langs = [];
        _this.isChanged = false;
        _this.isClosed = false;
        return _this;
    }
    LanguageComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.modal = this.remodalElement.nativeElement;
        this.service.setBaseUrl('/v1/language/current');
        this.service.getRecord().subscribe(function (data) {
            if (typeof data !== 'undefined') {
                _this.user_lang = data;
                _this.service.put(data);
            }
        });
    };
    LanguageComponent.prototype.onEvent = function () {
        var _this = this;
        this.isChanged = this.isClosed = false;
        this.current_lang = this.select_lang = this.user_lang.lang;
        this.save_default = false;
        this.service.setBaseUrl('/v1/language');
        this.service.getRecord().subscribe(function (data) {
            if (typeof data !== 'undefined' && typeof data['items'] !== 'undefined') {
                _this.langs = data['items'];
            }
            $(_this.modal).remodal({ hashTracking: false }).open();
            // let self = this;
            // $(document).on('closed', "[data-remodal-id=selectLanguage]", function () {
            //     if (!self.isChanged && !self.isClosed) {
            //         self.isClosed = true;
            //         if (self.select_lang != self.current_lang) {
            //             self.page.getCurrentPageWithLang(self.current_lang).subscribe();
            //         }
            //     }
            // });
        });
    };
    LanguageComponent.prototype.onChange = function () {
        // this.page.getCurrentPageWithLang(this.select_lang).subscribe();
    };
    LanguageComponent.prototype.language = function () {
        var _this = this;
        var lang;
        for (var i = 0; i < this.langs.length; i++) {
            if (this.select_lang === this.langs[i].lang) {
                lang = this.langs[i];
                break;
            }
        }
        if (this.save_default === true) {
            this.service.setBaseUrl('/v1/language/current/user');
        }
        else {
            this.service.setBaseUrl('/v1/language/current');
        }
        this.service.updateRecord(lang).subscribe(function (data) {
            _this.logger.debug('data:', data);
            _this.user_lang = data;
            _this.service.put(data);
            _this.isChanged = true;
            $(_this.modal).remodal().close();
            _this.page.getPage().subscribe(function () {
                _this.action.firstAction('languageChange');
            });
        }, function (error) {
            _this.logger.error(error);
        });
    };
    LanguageComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    LanguageComponent.prototype.trackByLang = function (index, lang) {
        return lang.lang;
    };
    LanguageComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            $(this.modal).remodal().destroy();
        }
    };
    LanguageComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'language',
                    template: "<a href=\"javascript:void(0);\" (click)=\"onEvent()\">\n  <img class=\"hNav_accountMenuLiFlag\" src=\"img/flags/earth.svg\" alt=\"\">{{ (msg | async)['SelectLanguageComponent.setlanguage'] }}\n</a>\n\n<!-- remodal -->\n<div class=\"remodal\" data-remodal-id=\"regionMenu\" #remodal>\n  <p>{{ (msg | async)['SelectLanguageComponent.selectlanguage'] }}</p>\n  <ul class=\"remodal_regionList\">\n    <li *ngFor=\"let lang of langs; trackBy: trackByLang\">\n      <input type=\"radio\" id=\"{{ lang.lang }}\" name=\"region\" value=\"{{ lang.lang }}\" [(ngModel)]=\"select_lang\" (change)=\"onChange()\">\n      <label for=\"{{ lang.lang }}\" class=\"remodal_regionList_btn\">\n        <img class=\"hNav_user_lang_flag\" src=\"{{ lang.img }}\" alt=\"\">{{ lang.label }}\n      </label>\n    </li>\n  </ul>\n  <div class=\"remodal_btns\">\n    <p *ngIf=\"saveDefaultLang\" class=\"remodal_btns_checkbox\">\n      <input type=\"checkbox\" id=\"setLang\" [(ngModel)]=\"save_default\">\n      <label for=\"setLang\" class=\"checkboxStyle\">{{ (msg | async)['SelectLanguageComponent.setdefault'] }}</label>\n    </p>\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">Cancel</button>\n      </li>\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"language()\">OK</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    LanguageComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: LanguageService }
    ]; };
    LanguageComponent.propDecorators = {
        saveDefaultLang: [{ type: Input }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return LanguageComponent;
}(ContentBaseComponent));
export { LanguageComponent };
//# sourceMappingURL=language.component.js.map